import { render, staticRenderFns } from "./AppMovilProveedores.vue?vue&type=template&id=2e82c66c&"
import script from "./AppMovilProveedores.vue?vue&type=script&lang=js&"
export * from "./AppMovilProveedores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports